import { HeroSlider } from "@/components/home/HeroSlider";
import { Ticker, DeptSplit, Process } from "@/components/home/HomeSections";
import { Testimonials } from "@/components/home/GalleryTestimonials";
import { DoctorProfile } from "@/components/common/DoctorProfile";
import { ServicesTabs } from "@/components/common/ServicesTabs";
import { AppointmentForm } from "@/components/common/AppointmentForm";
import { ContactBlock } from "@/components/common/ContactBlock";
import { DOCTORS } from "@/data/site";

export default function Home() {
  return (
    <div data-testid="home-page">
      <HeroSlider />
      <Ticker />
      <DeptSplit />
      <div id="doctors">
        {DOCTORS.map((d, i) => <DoctorProfile key={d.key} d={d} flip={i % 2 === 1} />)}
      </div>
      <ServicesTabs />
      <Process />
      <Testimonials />
      <AppointmentForm />
      <ContactBlock />
    </div>
  );
}
